export default "__VITE_ASSET__c40253fb__"